module.exports = __webpack_public_path__ + "static/media/korleis.5cb9086a.mp3";